import {useEffect} from "react";

import {useLazyGetUserOpinionsOfferQuery, useLazyGetUserOpinionsPropertyQuery} from "../api/offer_opinions_api";

export const useOfferUserOpinionResults = (offerId: number, propertyId?: number) => {
    const [fetchOfferOpinions, offerOpinions] = useLazyGetUserOpinionsOfferQuery();
    const [fetchPropertyOpinions, propertyOpinions] = useLazyGetUserOpinionsPropertyQuery();

    const data = propertyId ? propertyOpinions.data : offerOpinions.data;

    useEffect(() => {
        propertyId ? fetchPropertyOpinions({propertyId}) : fetchOfferOpinions({offerId});
    }, []);

    return {
        opinions: data,
        isLoading: propertyId ? propertyOpinions.isLoading : offerOpinions.isLoading,
        isUninitialized: propertyId ? propertyOpinions.isUninitialized : offerOpinions.isUninitialized,
        isError: propertyId ? propertyOpinions.isError : offerOpinions.isError
    };
};
import {useEffect} from "react";

import {useLazyGetUserOpinionsOfferQuery, useLazyGetUserOpinionsPropertyQuery} from "../api/offer_opinions_api";

export const useOfferUserOpinionResults = (offerId: number, propertyId?: number) => {
    const [fetchOfferOpinions, offerOpinions] = useLazyGetUserOpinionsOfferQuery();
    const [fetchPropertyOpinions, propertyOpinions] = useLazyGetUserOpinionsPropertyQuery();

    const data = propertyId ? propertyOpinions.data : offerOpinions.data;

    useEffect(() => {
        propertyId ? fetchPropertyOpinions({propertyId}) : fetchOfferOpinions({offerId});
    }, []);

    return {
        opinions: data,
        isLoading: propertyId ? propertyOpinions.isLoading : offerOpinions.isLoading,
        isUninitialized: propertyId ? propertyOpinions.isUninitialized : offerOpinions.isUninitialized,
        isError: propertyId ? propertyOpinions.isError : offerOpinions.isError
    };
};
